import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { IconButton, Typography } from '@mui/material';
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedCard } from 'components/enhanced/card/EnhancedCard';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'shared/utils/toast';
import { transportDocumentLineService } from '../api/transport-document-line.service';
import { transportDocumentService } from '../api/transport-document.service';
import { useTransportDocumentUniqueFieldsColumns } from '../hooks/useTransportDocumentUniqueFieldsColumns';
import TransportDocumentLineForm from './form/TransportDocumentRefLineForm';
import { EnhancedDialog } from 'components/enhanced';

interface UpdateDDTProps {
  ddtLineId?: number;
  supplierId?: number;
  supplierCode?: string;
  warehouseId?: number;
  warehouseCode?: string;
  onClose?: () => void;
}

export default function TransportDocumentLineUpdateDialog(params: UpdateDDTProps) {
  const { ddtLineId, supplierId, supplierCode, warehouseId, warehouseCode, onClose } = params;
  const translatePrefix = 'entities.ddt.edit-ddt';
  const { t } = useTranslation();

  const [openDialog, setOpenDialog] = useState(false);
  const [rows, setRows] = useState<Record<string, unknown>[]>([]);

  /**
   * Opens the confirmation dialog for deleting a row.
   *
   * @param {number} id - The ID of the row to be deleted.
   */
  const handleOpenDialog = () => {
    // Set the selected row ID and open the dialog.
    setOpenDialog(true);
  };

  /**
   * Closes the confirmation dialog.
   */
  const handleCloseDialog = () => {
    // Close the dialog and reset the selected row ID.
    setOpenDialog(false);
  };

  const handleUpdateDDT = (row: any) => {
    console.log('values', supplierCode, warehouseCode);
    transportDocumentLineService.update(ddtLineId, { document: row.id }).then(() => {
      toast.success(t(`${translatePrefix}.success-ddt`, { ddt_ref: row.ref }));
      // Close the dialog
      setOpenDialog(false);
      // Re Render the parent's table
      onClose();
    });
  };

  // colonne enhanchedDataGrid
  const columns: GridColDef[] = useTransportDocumentUniqueFieldsColumns(handleUpdateDDT);

  return (
    <>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          handleOpenDialog();
        }}>
        <DoubleArrowIcon fontSize="small" />
        <Typography variant="button" component="span" sx={{ textTransform: 'none' }}>
          {t(`${translatePrefix}.label`)}
        </Typography>
      </IconButton>

      <EnhancedDialog
        open={openDialog}
        onClose={handleCloseDialog}
        title={t(`${translatePrefix}.title`)}
        subTitle={t(`${translatePrefix}.message-ddt`, {
          supplier: supplierCode,
          warehouse: warehouseCode
        })}
        costumFooter={<></>}
        maxWidth="lg">
        <TransportDocumentLineForm
          handleSetTransportDocuments={(values) => {
            transportDocumentService
              .getOnlyBaseFields(0, 0, {
                ref__startswith: values?.ref,
                supplier_id: supplierId,
                warehouse_id: warehouseId
              })
              .then((res) => {
                if (res.count > 0) {
                  setRows(res.results);
                } else {
                  toast.error(t(`${translatePrefix}.wrong-ddt`));
                }
              });
          }}
        />

        <EnhancedCard>
          <DataGridPremium
            columns={columns}
            rows={rows}
            sx={{ border: 'none' }}
            disableRowSelectionOnClick
          />
        </EnhancedCard>
      </EnhancedDialog>
    </>
  );
}
